import { createFileRoute } from '@tanstack/react-router';
import FolderReadPage from '../components/FolderReadPage';

export const Route = createFileRoute('/_app/folder/$folderId/read/$id')({
  component: FolderReadPage,
});
